import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, filter, interval, map, startWith, switchMap } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { SendbirdChatService } from 'src/app/layouts/sendbird-chat/sendbird-chat.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { NotificationService } from 'src/app/pages/notification-center/notification.service';
import { VipApi } from 'src/app/shared/apis/vip.api';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    public layout: LayoutService,
    public appService: AppService,
    private notificationService: NotificationService,
    private vipApi: VipApi,
    private cardCenterService: CardCenterService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private sendbirdChatService: SendbirdChatService,
  ) {}

  isH5!: boolean;
  isMobile!: boolean;

  simple!: boolean;

  vipLoading: boolean = false;

  /** 是否是app */
  isApp?: boolean;

  /** 是否登录状态 */
  logined: boolean = false;

  showH5Logo: boolean = false;

  fullMode: boolean = false;
  isOpenSendbirdChat: boolean = false;

  @Input() layoutContentMarginLeft: string = '0px';

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.updateFullMode();
  }

  ngOnInit() {
    this.isApp = environment.isApp;
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => (this.isH5 = e));
    this.layout.isMobile$.pipe(untilDestroyed(this)).subscribe(e => (this.isMobile = e));
    this.layout.page$
      .pipe(untilDestroyed(this))
      .subscribe(e => (this.simple = ['register', 'login', 'password'].includes(e)));

    this.breakpointObserver
      .observe(['(max-width: 875px)'])
      .pipe(
        untilDestroyed(this),
        map((state: BreakpointState) => state.matches),
        distinctUntilChanged(),
      )
      .subscribe(e => {
        this.showH5Logo = e;
      });

    // 登录后如果为用户名注册显示提示弹窗
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe((v: AccountInforData | null) => {
      if (!v) return;
      this.logined = true;

      // 立即获取一次 VIP 信息，然后每 30 秒获取一次
      interval(30000)
        .pipe(
          startWith(0),
          switchMap(() => this.vipApi.getUserVip()),
          untilDestroyed(this),
        )
        .subscribe(vipInfo => {
          if (vipInfo) {
            this.appService.vipUserInfo$.next(vipInfo);
          }
        });

      // 获取卡券数量
      this.cardCenterService.getBonusCount();
    });

    this.router.events
      .pipe(
        untilDestroyed(this),
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe(() => this.updateFullMode());

    this.updateFullMode();

    this.sendbirdChatService.displayChat$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isOpenSendbirdChat = x;
    });
  }

  updateFullMode() {
    this.fullMode = false;
    this.layout.getComponentTree().forEach(x => {
      if (x._displayMode) {
        this.fullMode = {
          FullMode: true,
          normal: false,
        }[x._displayMode as 'FullMode' | 'normal'];
      }
    });
  }

  onMenuClick() {
    const currentLeftMenuState = this.layout.leftMenuState$.getValue();
    this.layout.leftMenuState$.next(!currentLeftMenuState);
  }
}
